import { CdkScrollable } from "@angular/cdk/scrolling";
import { ChangeDetectionStrategy, Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogContent, MatDialogRef, MatDialogTitle } from "@angular/material/dialog";
import { WidgetDto } from "@smallstack/axios-api-client";
import { IconComponent } from "@smallstack/theme-components";
import { WidgetRendererOptions, WidgetTreeComponent } from "@smallstack/widget-core";

export interface FloatingActionButtonDialogData {
  dialogComponent: WidgetDto;
  widgetRendererOptions: WidgetRendererOptions;
  context: any;
}

@Component({
  selector: "smallstack-floating-action-button-dialog",
  templateUrl: "./floating-action-button-dialog.component.html",
  styleUrls: ["./floating-action-button-dialog.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatDialogTitle, IconComponent, CdkScrollable, MatDialogContent, WidgetTreeComponent]
})
export class FloatingActionButtonDialogComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: FloatingActionButtonDialogData,
    public dialogRef: MatDialogRef<FloatingActionButtonDialogComponent>
  ) {
    data.widgetRendererOptions.dialogRef = dialogRef;
  }

  public close(): void {
    if (this.data.widgetRendererOptions?.editMode === true) this.dialogRef.close(this.data.dialogComponent);
    else this.dialogRef.close();
  }
}
